import { render, staticRenderFns } from "./OpenMetadata.vue?vue&type=template&id=1fb456d5&scoped=true"
import script from "./OpenMetadata.vue?vue&type=script&lang=js"
export * from "./OpenMetadata.vue?vue&type=script&lang=js"
import style0 from "./OpenMetadata.vue?vue&type=style&index=0&id=1fb456d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb456d5",
  null
  
)

export default component.exports